import Phaser from 'phaser';
import { BaseSpriteInterface } from './SpriteInterfaces';
export class DropItem extends Phaser.Physics.Matter.Sprite {
  static sound: Phaser.Sound.BaseSound;
  birthTime: number;
  minLifeSpan: number = 250; //(ms) Min time before this can be picked up
  name: string;
  constructor(data: BaseSpriteInterface, playerScale=1) {
    let { scene, x, y, frame } = data;
    console.log('frame:');
    console.log(frame);
    const texture = frame === 'heart' ? 'heart' : frame === 'brown_rock' ? 'landscapes' : frame === 'cookie' ? 'cookie': 'items';
    const frameToUse = frame === 'heart' || frame === 'cookie' ? null : frame;
    const scaler = frame === 'brown_rock' || frame === 'pawpaw' || frame === "persimmon" ? 0.5 : 1;
    super(scene.matter.world, x, y, texture, frameToUse);
    this.name = frame;
    this.scene.add.existing(this);
    const Bodies = new Phaser.Physics.Matter.MatterPhysics(scene).bodies;
    var circleCollider = Bodies.circle(this.x, this.y, 10*playerScale, {
      isSensor: false,
      label: 'dropItemCollider',
    });
    this.setExistingBody(circleCollider);
    this.setFrictionAir(1);
    this.setScale(playerScale*scaler);
    this.setDepth(0);
    this.birthTime = Date.now();
    if(texture === 'heart'){
      console.log("running heart_anims:");
      this.anims.play('beat', true);
    }
  }

  static preload(scene) {
    // load items atlas
    scene.load.atlas(
      'items',
      'assets/items/items.png',
      'assets/items/items_atlas.json'
    );
    scene.load.audio('pickup', 'assets/audio/pickup.mp3');

    // Load heart data
    scene.load.atlas(
      'heart',
      'assets/items/heart.png',
      'assets/items/heart_atlas.json'
    );
    scene.load.animation('heart_anims', 'assets/items/heart_anim.json');

    // Load cookie image
    scene.load.image('cookie', 'assets/items/UkropsRainbowCookie16x15.png');
  }

  pickup() {
    if (Date.now() - this.birthTime >= this.minLifeSpan) {
      DropItem.sound.play();
      this.destroy();
      return true;
    }
    return false;
  }
}
